import * as MainMenuActions from './lib/+state/actions';
import * as MainMenuSelectors from './lib/+state/selectors';

export * from './lib/shared-main-menu-data-access.module';
export { MainMenuActions };
export { MainMenuSelectors };
